import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import getSearchLink from 'helpers/getSearchLink'

import { SearchIcon } from '@pleio/icons/search'

import HideVisually from 'js/components/HideVisually/HideVisually'
import IconButton from 'js/components/IconButton'

import styles from './MobileNavigationSearch.module.css'

const MobileNavigationSearch = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const [value, setValue] = useState('')

    const onChange = (evt) => {
        setValue(evt.target.value)
    }

    const onSubmit = (evt) => {
        evt.preventDefault()
        navigate(
            getSearchLink({
                q: value.trim(),
            }),
        )
    }

    return (
        <form className={styles.wrapper} onSubmit={onSubmit} role="search">
            <HideVisually as="label" htmlFor="mobile-nav-search">
                {t('global.search')}
            </HideVisually>
            <input
                id="mobile-nav-search"
                className="Input"
                placeholder={t('global.search')}
                value={value}
                onChange={onChange}
            />
            <IconButton
                variant="secondary"
                radiusStyle="none"
                className="SubmitButton"
                type="submit"
                disabled={value === ''}
                aria-label={t('global.search')}
            >
                <SearchIcon />
            </IconButton>
        </form>
    )
}

export default MobileNavigationSearch
